import predefinedComponentNames from "app/components/flow/designer/predefinedComponents/predefinedComponentNames.json";
/*** USES_TEMPLATE ***/
/* not used anywhere, have to remove it.
 import allTemplates from "./resources/generated/templates.json"; */
import componentService from "../../../core/services/componentService/component-service";
import templateService from "../../../core/services/componentService/topology-info-service";
import appTypes from "src/modules/apps/pages/create-app-page-templates/services/create-app-page-app-types.const.json";
import growl from "../../../app/components/common/growl";
import App from "app";

var module = {};

/* module.licensingOptions = {
    default: [
        "oracleDB",
        "oracleCDC",
        "sqlServerDB",
        "sqlServerCDC",
        "MySqlDB",
        "MySqlCDC",
        "MSJet",
        "OJet",
        "PostgresCDC",
        "PostgresDB",
        "IncrementalBatch",
        "SnowflakePartnerConnectCDC",
        "SnowflakePartnerConnectIL",
        "GoogleBigQuery",
        "DeltaLake"
    ],
    AzureSQLServer: ["AzureSQLServer", "AzureHDInsight", "AzureStorage"],
    AzureHDInsight: ["AzureHDInsight", "AzureSQLServer", "AzureStorage"],
    AzureStorage: ["AzureStorage", "AzureHDInsight", "AzureSQLServer"],
    AzureDMS: [
        "oracleDB",
        "oracleCDC",
        "sqlServerDB",
        "sqlServerCDC",
        "MSJet",
        "OJet",
        "MySqlDB",
        "MySqlCDC",
        "PostgresDB"
    ],
    AzureSqlDW: ["AzureSQLDWH", "IncrementalBatch", "sqlServerCDC", "MSJet", "OJet", "oracleCDC", "MySqlCDC"],
    AzureSqlDwIncrementalSource: [
        "AzureSQLDWH",
        "IncrementalBatch",
        "sqlServerCDC",
        "MSJet",
        "OJet",
        "oracleCDC",
        "MySqlCDC"
    ],
    AzureCosmosDB: [
        "AzureCosmosCassandraDB",
        "AzureCosmosDB",
        "AzureSQLDWH",
        "AzureHDInsight",
        "sqlServerCDC",
        "MSJet",
        "AzureStorage",
        "AzureSQLServer",
        "AzureCosmosMongoDB"
    ],
    GooglePostgresSql: ["GooglePostgresSql", "GoogleMySql", "GoogleGCS", "GoogleBigQuery", "GoogleSpanner"],
    GoogleMySql: ["GoogleMySql", "GooglePostgresSql", "GoogleGCS", "GoogleBigQuery", "GoogleSpanner"],
    GoogleGCS: ["GoogleGCS", "GooglePostgresSql", "GoogleMySql", "GoogleBigQuery", "GoogleSpanner"],
    GoogleBigQuery: ["GoogleBigQuery", "GooglePostgresSql", "GoogleMySql", "GoogleGCS", "GoogleSpanner"],
    AzurePostgreSQL: ["AzurePostgreSQL", "AzureHDInsight", "AzureStorage", "AzureSQLDWH"],
    AwsRedShift: ["AwsRedShift", "oracleCDC", "sqlServerCDC", "MSJet", "OJet", "MySqlCDC"],
    GoogleSpanner: ["GoogleSpanner", "GoogleGCS", "GoogleBigQuery", "GooglePostgresSql", "GoogleMySql"],
    Snowflake: ["Snowflake", "oracleCDC", "sqlServerCDC", "MSJet", "OJet", "MySqlCDC"],
    DeltaLake: ["DeltaLake", "oracleCDC", "sqlServerCDC", "MSJet", "OJet", "MySqlCDC"],
    SnowflakePartnerConnect: ["SnowflakePartnerConnectIL", "SnowflakePartnerConnectCDC"],
    AppAdaptersStripe: ["AppAdaptersStripe"],
    AppAdaptersZendesk: ["AppAdaptersZendesk"],
    AppAdaptersHubspot: ["AppAdaptersHubspot"]
};
const CDCSources = ["OracleCDC", "PostgreSQLReader", "MSSQLCDC", "MSJet", "OJet", "MySQLCDC", "MariaDBReader"];
const DBSources = ["OracleIL", "", "MSSQLIL", "MySQLIL", "PostgreSQLIL", "MariaDBIL", "MariaDBXpandIL"];

const hasCDCSources = function(steps) {
    let intersection = CDCSources.filter(x => steps.includes(x));
    return intersection.length >= 1;
};

const hasDBSources = function(steps) {
    let intersection = DBSources.filter(x => steps.includes(x));
    return intersection.length >= 1;
};

module.campaigns = {
    defaultHero: {
        title: "Integrate into Snowflake",
        helpText: "Snowflake",
        filter: template => hasDBSources(template.steps) && template.uses.indexOf("DatabaseWriter") !== -1,
        icon: componentService.getIcon("SnowflakeWriter")
    },
    oracleCDC: {
        title: "Streaming Integration",
        helpText: "Oracle CDC",
        filter: template => template.steps.indexOf("OracleCDC") !== -1,
        icon: componentService.getIcon("OracleCDC")
    },
    OJet: {
        title: "Streaming Integration",
        filter: template => template.steps.indexOf("OJet") !== -1,
        icon: componentService.getIcon("OJet")
    },
    oracleDB: {
        title: "Initial Load",
        helpText: "Oracle",
        filter: template => template.steps.indexOf("OracleIL") !== -1,
        icon: componentService.getIcon("OracleIL")
    },
    sqlServerCDC: {
        title: "Streaming Integration",
        helpText: "SQL Server CDC",
        filter: template => template.steps.indexOf("MSSQLCDC") !== -1,
        icon: componentService.getIcon("MSSQLCDC")
    },
    sqlServerDB: {
        title: "Initial Load",
        helpText: "SQL Server",
        filter: template => template.steps.indexOf("MSSQLIL") !== -1,
        icon: componentService.getIcon("MSSQLIL")
    },
    MSJet: {
        title: "Streaming Integration",
        helpText: "MSJet",
        filter: template => template.steps.indexOf("MSJet") !== -1,
        icon: componentService.getIcon("MSJet")
    },

    MySqlCDC: {
        title: "Streaming Integration",
        helpText: "MySql CDC",
        filter: template => template.steps.indexOf("MySQLCDC") !== -1,
        icon: componentService.getIcon("MySQLCDC")
    },
    MySqlDB: {
        title: "Initial Load",
        helpText: "MySql",
        filter: template => template.steps.indexOf("MySQLIL") !== -1,
        icon: componentService.getIcon("MySQLIL")
    },
    PostgresCDC: {
        title: "Streaming Integration",
        helpText: "Postgres CDC",
        filter: template => template.steps.indexOf("PostgreSQLReader") !== -1,
        icon: componentService.getIcon("PostgreSQLReader")
    },
    PostgresDB: {
        title: "Initial Load",
        helpText: "Postgres DB",
        filter: template => template.steps.indexOf("PostgreSQLIL") !== -1,
        icon: componentService.getIcon("PostgreSQLIL")
    },
    AzureSQLServer: {
        title: "Streaming Integration",
        helpText: "Azure SQLServer",
        filter: template => template.steps.indexOf("OutputSQLServerDatabase") !== -1,
        icon: componentService.getIcon("OutputSQLServerDatabase")
    },
    AzureHDInsight: {
        title: "Streaming Integration",
        helpText: "Azure HD Insight",
        filter: template =>
            template.steps.indexOf("HDInsightHDFSWriter") !== -1 ||
            template.steps.indexOf("HDInsightKafkaWriter") !== -1,
        icon: componentService.getIcon("HDInsightHDFSWriter")
    },
    AzureStorage: {
        title: "Streaming Integration",
        helpText: "Azure Storage",
        filter: template => template.steps.indexOf("AzureDataLakeStoreGen2") !== -1,
        icon: componentService.getIcon("AzureDataLakeStoreGen2")
    },
    AzureEventHub: {
        title: "Streaming Integration",
        helpText: "Azure Event Hub",
        filter: template => template.steps.indexOf("AzureEventHubWriter") !== -1,
        icon: componentService.getIcon("AzureEventHubWriter")
    },
    AzureSQLDWH: {
        title: "Streaming Integration",
        helpText: "Azure SQL DWH",
        filter: template => template.steps.indexOf("AzureSQLDWHWriter") !== -1,
        icon: componentService.getIcon("AzureSQLDWHWriter")
    },
    IncrementalBatch: {
        title: "Streaming Integration",
        helpText: "Incremental Batch",
        filter: template => template.steps.indexOf("IncrementalBatchReader") !== -1,
        icon: componentService.getIcon("IncrementalBatchReader")
    },
    GooglePostgresSql: {
        title: "Streaming Integration",
        helpText: "Google Postgres Sql",
        filter: template => template.steps.indexOf("CloudSqlPostgreSqlWriter") !== -1,
        icon: componentService.getIcon("CloudSqlPostgreSqlWriter")
    },
    GoogleMySql: {
        title: "Streaming Integration",
        helpText: "Google MySql",
        filter: template => template.steps.indexOf("CloudSqlMySqlWriter") !== -1,
        icon: componentService.getIcon("CloudSqlMySqlWriter")
    },
    GoogleGCS: {
        title: "Streaming Integration",
        helpText: "Google GCS",
        filter: template => template.steps.indexOf("GCSWriter") !== -1,
        icon: componentService.getIcon("GCSWriter")
    },
    GoogleBigQuery: {
        title: "Streaming Integration",
        helpText: "Google Big Query",
        filter: template => template.steps.indexOf("BigQuery") !== -1,
        icon: componentService.getIcon("BigQuery")
    },
    AzureCosmosCassandraDB: {
        title: "Streaming Integration",
        helpText: "Azure Cosmos Cassandra DB",
        filter: template => template.steps.indexOf("CassandraCosmosDBWriter") !== -1,
        icon: componentService.getIcon("CassandraCosmosDBWriter")
    },
    AzureCosmosDB: {
        title: "Streaming Integration",
        helpText: "Azure Cosmos DB",
        filter: template => template.steps.indexOf("CosmosDBWriter") !== -1,
        icon: componentService.getIcon("CosmosDBWriter")
    },
    AzureCosmosMongoDB: {
        title: "Streaming Integration",
        helpText: "Azure Cosmos MongoDB",
        filter: template => template.steps.indexOf("MongoCosmosDBWriter") !== -1,
        icon: componentService.getIcon("MongoCosmosDBWriter")
    },
    AzurePostgreSQL: {
        title: "Streaming Integration",
        helpText: "Azure Postgres SQL",
        filter: template => template.steps.indexOf("AzurePostgreSqlWriter") !== -1,
        icon: componentService.getIcon("AzurePostgreSqlWriter")
    },
    AwsRedShift: {
        title: "Streaming Integration",
        helpText: "Amazon RedShift",
        filter: template => template.steps.indexOf("RedSh") !== -1,
        icon: componentService.getIcon("RedSh")
    },
    GoogleSpanner: {
        title: "Streaming Integration",
        helpText: "Google Spanner",
        filter: template => template.steps.indexOf("SpannerWriter") !== -1,
        icon: componentService.getIcon("SpannerWriter")
    },
    Snowflake: {
        title: "Snowflake",
        helpText: "Snowflake",
        filter: template => template.steps.indexOf("SnowflakeWriter") !== -1,
        icon: componentService.getIcon("SnowflakeWriter")
    },
    SnowflakePartnerConnectIL: {
        title: "Initial Load",
        helpText: "Snowflake Partner Connect IL",
        filter: template => template.steps.indexOf("SnowflakeWriter") !== -1 && hasDBSources(template.steps),
        icon: componentService.getIcon("SnowflakeWriter")
    },
    SnowflakePartnerConnectCDC: {
        title: "Streaming Integration",
        helpText: "Snowflake Partner Connect CDC",
        filter: template => template.steps.indexOf("SnowflakeWriter") !== -1 && hasCDCSources(template.steps),
        icon: componentService.getIcon("SnowflakeWriter")
    },
    Salesforce: {
        title: "Salesforce",
        helpText: "Salesforce",
        filter: template => template.steps.indexOf("Salesforce") !== -1 && hasCDCSources(template.steps),
        icon: componentService.getIcon("Salesforce")
    },
    File: {
        title: "File",
        helpText: "File",
        filter: template => template.steps.indexOf("File") !== -1 && hasCDCSources(template.steps),
        icon: componentService.getIcon("OutputFile")
    },
    DeltaLake: {
        title: "Streaming Integration to Databricks",
        filter: template => template.steps.indexOf("DeltaLakeWriter") !== -1,
        icon: componentService.getIcon("DeltaLakeWriter")
    },
    AppAdaptersStripe: {
        title: "Stripe Apps (Pipelines)",
        filter: template => template.steps.indexOf("StripeReader") !== -1,
        icon: componentService.getIcon("StripeReader")
    },
    AppAdaptersZendesk: {
        title: "Zendesk Apps (Pipelines)",
        filter: template => template.steps.indexOf("ZendeskReader") !== -1,
        icon: componentService.getIcon("ZendeskReader")
    },
    AppAdaptersHubspot: {
        title: "HubSpot Apps (Pipelines)",
        filter: template => template.steps.indexOf("HubSpotReader") !== -1,
        icon: componentService.getIcon("HubSpotReader")
    },
    MariaDBXpandDB: {
        title: "Initial Load",
        helpText: "MariaDB Xpand",
        filter: template => template.steps.indexOf("MariaDBXpandDB") !== -1,
        icon: predefinedComponentNames["MariaDBXpandDB"].className
    },
    Db2zOSIL: {
        title: "Initial Load",
        helpText: "Db2 for z/OS",
        filter: template => template.steps.indexOf("Db2zOSIL") !== -1,
        icon: predefinedComponentNames["Db2zOSIL"].className
    },
    CrunchyDataILReader: {
        title: "Initial Load",
        helpText: "Crunchy Data",
        filter: template => template.steps.indexOf("CrunchyDataILReader") !== -1,
        icon: predefinedComponentNames["CrunchyDataILReader"].className
    },
    CrunchyDataCDCReader: {
        title: "Streaming Integration",
        helpText: "Crunchy Data",
        filter: template => template.steps.indexOf("CrunchyDataCDCReader") !== -1,
        icon: predefinedComponentNames["CrunchyDataCDCReader"].className
    },
    NeonILReader: {
        title: "Initial Load",
        helpText: "Neon",
        filter: template => template.steps.indexOf("NeonILReader") !== -1,
        icon: predefinedComponentNames["NeonILReader"].className
    },
    NeonCDCReader: {
        title: "Streaming Integration",
        helpText: "Neon",
        filter: template => template.steps.indexOf("NeonCDCReader") !== -1,
        icon: predefinedComponentNames["NeonCDCReader"].className
    }
};

module.adapterToCampaign = {
    "Global.PROPERTYTEMPLATE.OracleReader": "oracleCDC",
    "Global.PROPERTYTEMPLATE.MysqlReader": "MySqlCDC",
    "Global.PROPERTYTEMPLATE.MSSqlReader": "sqlServerCDC",
    "Global.PROPERTYTEMPLATE.PostgreSQLReader": "PostgreSQLCDC"
};

module.templatesList = allTemplates; */

//To Do : Add comments as discussed
module.getByURL = function(url) {
    try {
        const { source, target } = templateService.getTopologyInfoFromURL(url);
        if (!componentService.checkIfValidComponent(source) || !componentService.checkIfValidComponent(target)) {
            growl.error(`Invalid source or target component in URL: ${source} → ${target}`);
            App.navigate("/create-app", { trigger: true });
            return null;
        }
        const appType = new String(url).includes("-automated-ILCDC") ? appTypes.AUTOMATEDILCDC : null;
        const template = templateService.generateTopologyInfo({ source, target, appType });
        return template;
    } catch (error) {
        growl.error(error);
        App.navigate("/create-app", { trigger: true });
        return null;
    }
};

export default module;
